import React from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowLeftLong,
    faPaperPlane,
    faSave,
} from '@fortawesome/free-solid-svg-icons';
import { isValid } from './TimeOffRequest';
import { TimesheetStatus } from '../timesheet/Timesheet';
import TimeOffRequestRejectButton from './TimeOffRequestRejectButton';
import TimeOffRequestAcceptButton from './TimeOffRequestAcceptButton';

export default class TimeOffRequestActionBar extends React.Component {
    render() {
        const {
            loading,
            anyChanges,
            onSaveClick,
            saving,
            timeOffRequest,
            onBackClick,
            onSubmitClick,
            isAdmin,
        } = this.props;

        if (loading) {
            return null;
        }

        return (
            <div className="d-flex time-off-request-actions">
                <div>
                    <Button
                        type="button"
                        outline={true}
                        color="warning"
                        onClick={onBackClick}
                    >
                        <FontAwesomeIcon
                            icon={faArrowLeftLong}
                            className="mr-1"
                        />{' '}
                        Back
                    </Button>
                </div>

                {timeOffRequest.createdByCurrentUser &&
                    (timeOffRequest.id == 0 ||
                        timeOffRequest.timesheetStatusId ==
                            TimesheetStatus.New) && (
                        <>
                            <div>
                                <Button
                                    type="button"
                                    disabled={
                                        !anyChanges || !isValid(timeOffRequest)
                                    }
                                    outline={!anyChanges}
                                    color="info"
                                    onClick={onSaveClick}
                                >
                                    <FontAwesomeIcon
                                        icon={faSave}
                                        className="mr-1"
                                        pulse={saving}
                                    />{' '}
                                    Save
                                </Button>
                            </div>

                            <div>
                                <Button
                                    type="button"
                                    disabled={!isValid(timeOffRequest)}
                                    outline={!isValid(timeOffRequest)}
                                    color="success"
                                    onClick={onSubmitClick}
                                >
                                    <FontAwesomeIcon
                                        icon={faPaperPlane}
                                        className="mr-1"
                                        pulse={saving}
                                    />
                                    Submit
                                </Button>
                            </div>
                        </>
                    )}

                {!timeOffRequest.createdByCurrentUser && isAdmin && (
                    <>
                        <div>
                            <TimeOffRequestRejectButton {...this.props} />
                        </div>
                        <div>
                            <TimeOffRequestAcceptButton {...this.props} />
                        </div>
                    </>
                )}
            </div>
        );
    }
}
